import { useTranslation } from '@mint-lib/i18n';
import { Button } from '@mint-lib/tw-components';

import { useReadOnly } from '../hooks/useReadOnly.js';
import type { ConnectionPlatformDisplay } from '../types.js';

interface Props {
  platform: ConnectionPlatformDisplay;
  onReconnect?: () => void;
  text?: string;
  /** Datadog action name, forwarded unchanged; pass a per-platform literal. */
  'data-dd-action-name': string;
}

export const ReconnectButton = ({
  platform,
  onReconnect,
  text,
  'data-dd-action-name': actionName,
}: Props) => {
  const { t } = useTranslation('@mint-lib/connections-ui');
  const isUserReadOnly = useReadOnly();

  const logo = platform?.iconUrl ?? '';

  return (
    <Button
      variant="text"
      onClick={onReconnect}
      disabled={isUserReadOnly}
      aria-disabled={isUserReadOnly}
      data-dd-action-name={actionName}
      className="ui-primary disabled:ui-primary text-text-primary shadow-md"
      size="large"
    >
      {logo && (
        <img
          src={logo}
          alt={`${platform?.label} logo`}
          className="mr-2.5 h-5 w-5"
        />
      )}
      {text ||
        t('Reconnect {{platformName}} Account', {
          platformName: platform?.label,
        })}
    </Button>
  );
};
